import { render, staticRenderFns } from "./dzzssecond.vue?vue&type=template&id=29e3232f&scoped=true&"
import script from "./dzzssecond.vue?vue&type=script&lang=js&"
export * from "./dzzssecond.vue?vue&type=script&lang=js&"
import style0 from "./dzzssecond.vue?vue&type=style&index=0&id=29e3232f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3232f",
  null
  
)

export default component.exports